export function matchWebSubroutinesName(web_subroutines_name: string) {
    if(web_subroutines_name === 'EVENT_ID_2') {
        return '2';
    }else if(web_subroutines_name === 'EVENT_ID_2_M') {
        return '2_M';
    }else if(web_subroutines_name === 'EVENT_ID_2_5') {
        return '2_5';
    }else if(web_subroutines_name ==='EVENT_ID_3') {
        return '3';
    }else if(web_subroutines_name === 'EVENT_ID_3_M') {
        return '3_M';
    }else{
        return '-';
    }
}